var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx, ClassNames } from '@emotion/core';
import * as React from 'react';
import { validateIconType } from './utils';
var Svg = (function (_super) {
    __extends(Svg, _super);
    function Svg() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Svg.prototype.render = function () {
        var _a = this.props, src = _a.src, styles = _a.styles, type = _a.type, iconRef = _a.iconRef, elemProps = __rest(_a, ["src", "styles", "type", "iconRef"]);
        try {
            validateIconType(src, type);
        }
        catch (e) {
            console.error(e);
            return null;
        }
        return (jsx(ClassNames, null, function (_a) {
            var css = _a.css, cx = _a.cx;
            return (jsx("span", __assign({}, elemProps, { dangerouslySetInnerHTML: { __html: src.svg }, className: cx(css(styles, {
                    display: 'inline-block',
                    '& svg': { display: 'block' },
                }), elemProps.className), ref: iconRef })));
        }));
    };
    return Svg;
}(React.Component));
export default Svg;
